import { css } from 'lit';
export const styles = css `
  /*
  @TODO:

  Move space & font sizes to Tokens
 */
  :host {
    --navbar-space-1: 8px;
    --navbar-space-5: 12px;
    --navbar-space-2: 16px;
    --navbar-space-3: 20px;
    --navbar-space-4: calc(var(--navbar-space-2) * 2);

    --navbar-padding-top: var(--navbar-space-5);
    --navbar-padding-bottom: var(--navbar-space-5);

    --section-space: 40px;
  }

  /*
    browser default reset
  */
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .navbar {
    background-color: var(--grain-color-background-1);
    padding-top: var(--navbar-padding-top);
    padding-right: var(--navbar-space-3);
    padding-bottom: var(--navbar-padding-bottom);
    padding-left: var(--navbar-space-3);
    /* Ensure navbar stays in place on mobile */
    position: relative;
    z-index: 1000;
  }

  .search {
    margin-left: auto;
    margin-right: 16px;
  }

  .banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .menu {
    padding-top: 24px;
    padding-bottom: var(--section-space);
    /* Fix for mobile scrolling issue */
    max-height: calc(100vh - 80px); /* Account for banner height */
    overflow-y: auto;
    position: relative;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    
    /* Hide scrollbar while maintaining functionality */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    
    &::-webkit-scrollbar {
      display: none; /* WebKit browsers */
    }
  }

  .primary-link-container {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    gap: 12px;
  }

  .icon-external {
    margin-left: 8px;
    margin-bottom: 3px;
  }

  .divider {
    display: block;
    height: 1px;
    background-color: var(--grain-global-color-gray-700);
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .secondary-link-container {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    column-gap: 20px;
    margin-top: 24px;
    margin-bottom: 0;
  }

  .nav-link--secondary {
    display: block;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 15px;
    line-height: 21px;
    color: var(--grain-color-typography-text-secondary);
    text-decoration: none;
  }

  .is-hidden {
    display: none;
  }

  .menu-button {
    display: flex;
    /*
      Reset default
      @TODO: Integrate Icon component
      into Button component
    */
    background-color: transparent;
    border: 0;
    padding: 0;
  }

  .menu-button {
    & :hover {
      cursor: pointer;
    }
  }

  .menu-content {
    margin-top: var(--section-space);
  }

  .menu-content-item {
    &:not(:last-child) {
      margin-bottom: var(--navbar-space-2);
    }
  }

  /* account variant */
  .menu-content-item--account {
    display: flex;

    & > * {
      flex: 1;
    }

    & :not(:last-child) {
      margin-right: 10px;
    }
  }

  /* Global styles to prevent body scroll when navbar menu is open */
  :host(.navbar-menu-open) {
    /* Add a class to prevent body scroll when menu is open */
  }

  /* Improve mobile touch scrolling */
  @media (max-width: 768px) {
    .menu {
      /* Better mobile scrolling experience */
      max-height: calc(100vh - 120px); /* Adjust for smaller mobile header */
      overscroll-behavior: contain; /* Prevent scroll chaining */
      padding-bottom: calc(var(--section-space) + 20px); /* Extra bottom padding for small screens */
    }
    
    .navbar {
      /* Ensure navbar covers full width on mobile */
      margin: 0;
      padding-left: var(--navbar-space-2);
      padding-right: var(--navbar-space-2);
    }
  }

  /* Extra small mobile screens (like 320px width) */
  @media (max-width: 375px) and (max-height: 600px) {
    .menu {
      max-height: calc(100vh - 90px); /* Even smaller header allowance */
      padding-bottom: calc(var(--section-space) + 30px); /* More bottom padding */
    }
  }

  /* Ultra small screens (320x568 and similar) */
  @media (max-width: 320px) {
    .menu {
      max-height: calc(100vh - 85px); /* Minimal header space */
      padding-bottom: calc(var(--section-space) + 40px); /* Maximum bottom padding */
    }
  }
`;
